/**
 * Centralized styling constants for form fields
 * This ensures consistent styling across all field types, including new ones from backend
 */

export const fieldStyles = {
  // Common input styles
  input: {
    base: "bg-[var(--color-background-neutral-subtlest,#131d2d)] border border-[var(--color-border-secondary-subtlest,#293950)] rounded-[4px] text-[14px] leading-[20px] text-[var(--color-foreground-secondary-bold,#f3f4f7)] placeholder:text-[var(--color-foreground-neutral-subtle,#9ea1b1)]",
    focus:
      "focus:outline-none focus:ring-2 focus:ring-[var(--color-border-primary-subtle,#5e6dff)]",
    padding: "px-3 py-3",
  },

  // Textarea specific styles
  textarea: {
    base: "bg-[var(--color-background-neutral-subtlest,#131d2d)] border border-[var(--color-border-secondary-subtlest,#293950)] rounded-[4px] px-3 py-3 text-[14px] leading-[20px] text-[var(--color-foreground-secondary-bold,#f3f4f7)] placeholder:text-[var(--color-foreground-neutral-subtle,#9ea1b1)] resize-y",
    focus:
      "focus:outline-none focus:ring-2 focus:ring-[var(--color-border-primary-subtle,#5e6dff)]",
  },

  // Container styles
  container: {
    base: "flex flex-col gap-1",
  },
} as const;

/**
 * Helper function to combine field styles
 */
export function combineFieldStyles(
  ...styleClasses: (string | undefined)[]
): string {
  return styleClasses.filter(Boolean).join(" ");
}
